// currencies.js — 30 currencies with fallback rates

export const CURRENCIES = {
  USD: { name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
  EUR: { name: 'Euro', symbol: '€', flag: '🇪🇺' },
  GBP: { name: 'British Pound', symbol: '£', flag: '🇬🇧' },
  INR: { name: 'Indian Rupee', symbol: '₹', flag: '🇮🇳' },
  CAD: { name: 'Canadian Dollar', symbol: 'CA$', flag: '🇨🇦' },
  AUD: { name: 'Australian Dollar', symbol: 'A$', flag: '🇦🇺' },
  JPY: { name: 'Japanese Yen', symbol: '¥', flag: '🇯🇵' },
  SGD: { name: 'Singapore Dollar', symbol: 'S$', flag: '🇸🇬' },
  AED: { name: 'UAE Dirham', symbol: 'AED', flag: '🇦🇪' },
  SEK: { name: 'Swedish Krona', symbol: 'kr', flag: '🇸🇪' },
  CHF: { name: 'Swiss Franc', symbol: 'Fr', flag: '🇨🇭' },
  CNY: { name: 'Chinese Yuan', symbol: '¥', flag: '🇨🇳' },
  BRL: { name: 'Brazilian Real', symbol: 'R$', flag: '🇧🇷' },
  MXN: { name: 'Mexican Peso', symbol: '$', flag: '🇲🇽' },
  KRW: { name: 'South Korean Won', symbol: '₩', flag: '🇰🇷' },
  ZAR: { name: 'South African Rand', symbol: 'R', flag: '🇿🇦' },
  NZD: { name: 'New Zealand Dollar', symbol: 'NZ$', flag: '🇳🇿' },
  HKD: { name: 'Hong Kong Dollar', symbol: 'HK$', flag: '🇭🇰' },
  NOK: { name: 'Norwegian Krone', symbol: 'kr', flag: '🇳🇴' },
  DKK: { name: 'Danish Krone', symbol: 'kr', flag: '🇩🇰' },
  PLN: { name: 'Polish Zloty', symbol: 'zł', flag: '🇵🇱' },
  THB: { name: 'Thai Baht', symbol: '฿', flag: '🇹🇭' },
  MYR: { name: 'Malaysian Ringgit', symbol: 'RM', flag: '🇲🇾' },
  IDR: { name: 'Indonesian Rupiah', symbol: 'Rp', flag: '🇮🇩' },
  PHP: { name: 'Philippine Peso', symbol: '₱', flag: '🇵🇭' },
  SAR: { name: 'Saudi Riyal', symbol: '﷼', flag: '🇸🇦' },
  TRY: { name: 'Turkish Lira', symbol: '₺', flag: '🇹🇷' },
  ILS: { name: 'Israeli Shekel', symbol: '₪', flag: '🇮🇱' },
  CZK: { name: 'Czech Koruna', symbol: 'Kč', flag: '🇨🇿' },
  HUF: { name: 'Hungarian Forint', symbol: 'Ft', flag: '🇭🇺' },
};

// Fallback rates (USD base, approx 2024)
export const FALLBACK_RATES = {
  USD: 1, EUR: 0.92, GBP: 0.79, INR: 83.5, CAD: 1.36, AUD: 1.53,
  JPY: 150.2, SGD: 1.34, AED: 3.67, SEK: 10.5, CHF: 0.90, CNY: 7.24,
  BRL: 4.97, MXN: 17.2, KRW: 1325, ZAR: 18.6, NZD: 1.63, HKD: 7.82,
  NOK: 10.7, DKK: 6.88, PLN: 3.97, THB: 35.1, MYR: 4.71, IDR: 15800,
  PHP: 56.5, SAR: 3.75, TRY: 32.5, ILS: 3.71, CZK: 23.1, HUF: 358
};

export const CURRENCY_LIST = Object.entries(CURRENCIES).map(([code, data]) => ({
  code, ...data
}));